import React from 'react';
import { Checkbox } from '../checkbox';
import { PropertiesPanelProperty, PropertiesPanelPropertyContent } from './propertiesPanelProperty';

export type PropertiesPanelCheckboxPropertyProps = {
    id: string;
    label: React.ReactNode;
    checked: boolean;
    onChange?: (checked: boolean) => void;
    disabled?: boolean;
};
export const PropertiesPanelCheckboxProperty: React.FC<PropertiesPanelCheckboxPropertyProps> = ({ id, label, checked, onChange, disabled }) => {
    return (
        <PropertiesPanelProperty>
            <PropertiesPanelPropertyContent>
                <Checkbox
                    disabled={disabled}
                    checked={checked}
                    label={label}
                    onChange={(checked) => {
                        onChange?.(checked);
                    }}
                />
            </PropertiesPanelPropertyContent>
        </PropertiesPanelProperty>
    );
};
